module.exports = __webpack_public_path__ + "img/light-r.fedde22b.png";